import React from "react";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";

export default function AddTrainerModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="trainer-modal">
      <Modal.Header closeButton>
        <Modal.Title>Add Trainer</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Role</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select>
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="footer-btns">
          <Button className="cancel-btn" onClick={onHide}>
            Cancel
          </Button>
          <Button className="submit-btn">Add Trainer</Button>
        </div>
      </Modal.Footer>

      {/* EXACT STYLE MATCH */}
      <style>{`
        .trainer-modal .modal-content {
          border-radius: 10px;
          background: #f9fafb;
          border: none;
        }

        .trainer-modal .modal-header {
          border-bottom: 1px solid #e5e7eb;
          padding: 18px 20px;
        }

        .trainer-modal .modal-title {
          font-size: 20px;
          font-weight: 600;
        }

        .trainer-modal .modal-body {
          padding: 20px;
        }

        .trainer-modal .form-label {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 6px;
          color: #374151;
        }

        .trainer-modal .form-control,
        .trainer-modal .form-select {
          height: 44px;
          border-radius: 6px;
          border: 1px solid #e5e7eb;
          font-size: 14px;
        }

        .trainer-modal textarea.form-control {
          height: auto;
          resize: none;
        }

        .trainer-modal .modal-footer {
          border-top: 1px solid #e5e7eb;
          padding: 15px 20px;
        }

        .footer-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .cancel-btn {
          background: #e5e7eb;
          border: none;
          color: #111827;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .submit-btn {
          background: #ff6b2c;
          border: none;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .submit-btn:hover {
          background: #e65a1f;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .trainer-modal .modal-dialog {
            margin: 10px;
          }

          .trainer-modal .modal-body {
            padding: 15px;
          }

          .footer-btns {
            flex-direction: column;
          }

          .footer-btns button {
            width: 100%;
          }
        }
      `}</style>
    </Modal>
  );
}